module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/18-0eb234ccc14dd7eb3cdf34609bde0d97.png";